import SignInView from '@/contexts/authentication/SignInView.vue'
import ForgotPasswordView from '@/contexts/authentication/ForgotPasswordView.vue'
import PasswordResetView from '@/contexts/authentication/PasswordResetView.vue'
import { lazyLoadView, _ } from '@/router/routing'
import type { RouteConfig } from 'vue-router'

// login, forgot_password, password_reset and sso don't need to be login

export const authRoutes: RouteConfig[] = [
  {
    path: '/login',
    name: 'login',
    component: SignInView,
    meta: {
      title: _('Sign in'),
      requires_auth: false,
    },
  },
  {
    path: '/forgot_password',
    name: 'forgot_password',
    component: ForgotPasswordView,
    meta: {
      title: _('Forgot password'),
      requires_auth: false,
    },
  },
  {
    path: '/password_reset/:token',
    name: 'password_reset',
    component: PasswordResetView,
    meta: {
      title: _('Password reset'),
      requires_auth: false,
    },
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => lazyLoadView(import('@/contexts/authentication/SsoView.vue')),
    meta: {
      title: _('Single Sign On'),
      requires_auth: false,
    },
  },
]
